// レシート一覧の絞り込みチップ
//
// 一覧の行に出しているバッジと同じ観点で絞れるようにする。
// 絞り込みそのものはサーバー側で行い、件数は /receipts/summary から貰う。
import type { ReceiptFilterFlag, ReceiptListSummary } from '@/api/types/receipt'

export type { ReceiptFilterFlag }

export type ReceiptFilterSpec = {
  value: ReceiptFilterFlag
  label: string
  color: string
  /** チップに出す件数を summary のどのキーから取るか */
  countKey: keyof Pick<ReceiptListSummary, 'place_count' | 'error_count' | 'diff_count'>
}

export const RECEIPT_FILTERS: readonly ReceiptFilterSpec[] = [
  {
    value: 'place',
    label: '場所未確定',
    color: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
    countKey: 'place_count',
  },
  {
    value: 'error',
    label: '検算エラー',
    color: 'bg-red-500/15 text-red-400 border-red-500/30',
    countKey: 'error_count',
  },
  {
    value: 'diff',
    label: 'AI不一致',
    color: 'bg-sky-500/15 text-sky-400 border-sky-500/30',
    countKey: 'diff_count',
  },
]

export const isReceiptFilterFlag = (value: string): value is ReceiptFilterFlag =>
  RECEIPT_FILTERS.some((filter) => filter.value === value)
